import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const QuotationsList = () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations/List.vue');
const QuotationCreate = () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations/Create.vue');
const QuotationEdit = () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations/Edit.vue');
const QuotationShow = () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations/Show.vue');

let quotationsPages = {
  path: '/quotations',
  redirect: '/quotations',
  component: DashboardLayout,
  name: 'Quotations',
  meta: {
    title: 'Cotizaciones',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'QuotationsList',
      meta: {
        title: 'Listado',
        auth: ['quotations.index'],
      },
      component: QuotationsList,
    },
    {
      path: 'create',
      name: 'QuotationCreate',
      meta: {
        title: 'Nueva',
        auth: ['quotations.store'],
      },
      component: QuotationCreate,
    },
    {
      path: ':id',
      name: 'QuotationShow',
      meta: {
        title: 'Detalle',
        auth: ['quotations.show'],
      },
      component: QuotationShow,
    },
    {
      path: ':id/edit',
      name: 'QuotationEdit',
      meta: {
        title: 'Editar',
        auth: ['quotations.update'],
      },
      component: QuotationEdit,
    },
  ],
};

export default quotationsPages;
